import React from 'react';

import renderMarkdown from '../../markdownProcessor';

const MarkdownField = ({ content, components }) => renderMarkdown(content, components);

export default MarkdownField;
